import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

interface CommandItem {
 id: string;
 title: string;
 subtitle?: string;
 icon: React.ReactNode;
 action: () => void;
 keywords?: string[];
 category: "navigation" | "action" | "recent" | "help";
}

/**
 * Icons for command items
 */
const Icons = {
 dashboard: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"/>
 </svg>
 ),
 projects: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"/>
 </svg>
 ),
 tasks: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
 </svg>
 ),
 timesheet: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
 </svg>
 ),
 users: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"/>
 </svg>
 ),
 settings: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"/>
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
 </svg>
 ),
 help: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"/>
 </svg>
 ),
 logout: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"/>
 </svg>
 ),
 leaves: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"/>
 </svg>
 ),
 worklogs: (
 <svg
 className="h-4 w-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={1.5}
 >
 <path
 strokeLinecap="round"strokeLinejoin="round"d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
 </svg>
 ),
};

/**
 * CommandPalette - Global search and navigation (Cmd+K / Ctrl+K)
 * Provides quick access to pages, actions, and help
 */
export function CommandPalette() {
 const [isOpen, setIsOpen] = useState(false);
 const [query, setQuery] = useState("");
 const [selectedIndex, setSelectedIndex] = useState(0);
 const inputRef = useRef<HTMLInputElement>(null);
 const navigate = useNavigate();

 // Define all available commands
 const commands: CommandItem[] = useMemo(
 () => [
 // Navigation
 {
 id: "nav-dashboard",
 title: "Go to Dashboard",
 subtitle: "View your overview and stats",
 icon: Icons.dashboard,
 action: () => navigate("/dashboard"),
 keywords: ["home","overview","main"],
 category: "navigation",
 },
 {
 id: "nav-projects",
 title: "Go to Projects",
 subtitle: "View all projects",
 icon: Icons.projects,
 action: () => navigate("/projects"),
 keywords: ["project","folder"],
 category: "navigation",
 },
 {
 id: "nav-tasks",
 title: "Go to My Tasks",
 subtitle: "View tasks assigned to you",
 icon: Icons.tasks,
 action: () => navigate("/my-tasks"),
 keywords: ["task","todo","work"],
 category: "navigation",
 },
 {
 id: "nav-timesheets",
 title: "Go to Timesheets",
 subtitle: "Manage your time entries",
 icon: Icons.timesheet,
 action: () => navigate("/timesheets"),
 keywords: ["time","hours","weekly"],
 category: "navigation",
 },
 {
 id: "nav-worklogs",
 title: "Go to Work Logs",
 subtitle: "View your logged hours",
 icon: Icons.worklogs,
 action: () => navigate("/worklogs"),
 keywords: ["log","hours","time"],
 category: "navigation",
 },
 {
 id: "nav-leaves",
 title: "Go to Leaves",
 subtitle: "Request and manage time off",
 icon: Icons.leaves,
 action: () => navigate("/leaves"),
 keywords: ["vacation","pto","time off","absence"],
 category: "navigation",
 },
 {
 id: "nav-users",
 title: "Go to Users",
 subtitle: "Manage team members",
 icon: Icons.users,
 action: () => navigate("/users"),
 keywords: ["employees","team","people","members"],
 category: "navigation",
 },
 {
 id: "nav-settings",
 title: "Go to Settings",
 subtitle: "Configure your account",
 icon: Icons.settings,
 action: () => navigate("/settings"),
 keywords: ["preferences","config","profile"],
 category: "navigation",
 },
 // Help
 {
 id: "help-guide",
 title: "Open Help Guide",
 subtitle: "Learn how to use the app",
 icon: Icons.help,
 action: () => {
 const event = new CustomEvent("openHelp");
 window.dispatchEvent(event);
 },
 keywords: ["documentation","guide","how to","tutorial"],
 category: "help",
 },
 // Actions
 {
 id: "action-logout",
 title: "Log Out",
 subtitle: "Sign out of your account",
 icon: Icons.logout,
 action: () => {
 localStorage.removeItem("accessToken");
 localStorage.removeItem("refreshToken");
 window.location.href ="/login";
 },
 keywords: ["sign out","exit"],
 category: "action",
 },
 ],
 [navigate],
 );

 // Filter commands based on query
 const filteredCommands = useMemo(() => {
 if (!query.trim()) return commands;

 const lowerQuery = query.toLowerCase();
 return commands.filter((cmd) => {
 const searchText = [cmd.title, cmd.subtitle, ...(cmd.keywords || [])]
 .join("")
 .toLowerCase();

 return searchText.includes(lowerQuery);
 });
 }, [commands, query]);

 // Reset selection when results change
 useEffect(() => {
 setSelectedIndex(0);
 }, [filteredCommands]);

 // Keyboard shortcut to open (Cmd+K / Ctrl+K)
 useEffect(() => {
 const handleKeyDown = (e: KeyboardEvent) => {
 if ((e.metaKey || e.ctrlKey) && e.key ==="k") {
 e.preventDefault();
 setIsOpen(true);
 }
 if (e.key ==="Escape") {
 setIsOpen(false);
 }
 };

 document.addEventListener("keydown", handleKeyDown);
 return () => document.removeEventListener("keydown", handleKeyDown);
 }, []);

 // Focus input when opened
 useEffect(() => {
 if (isOpen) {
 inputRef.current?.focus();
 } else {
 setQuery("");
 setSelectedIndex(0);
 }
 }, [isOpen]);

 // Handle keyboard navigation
 const handleKeyDown = useCallback(
 (e: React.KeyboardEvent) => {
 switch (e.key) {
 case"ArrowDown":
 e.preventDefault();
 setSelectedIndex((i) => Math.min(i + 1, filteredCommands.length - 1));
 break;
 case"ArrowUp":
 e.preventDefault();
 setSelectedIndex((i) => Math.max(i - 1, 0));
 break;
 case"Enter":
 e.preventDefault();
 if (filteredCommands[selectedIndex]) {
 filteredCommands[selectedIndex].action();
 setIsOpen(false);
 }
 break;
 }
 },
 [filteredCommands, selectedIndex],
 );

 if (!isOpen) return null;

 return (
 <div className="fixed inset-0 z-50 overflow-y-auto">
 {/* Backdrop */}
 <div
 className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity"onClick={() => setIsOpen(false)}
 />

 {/* Dialog */}
 <div className="flex min-h-full items-start justify-center p-4 pt-[15vh]">
 <div
 className="relative w-full max-w-xl transform rounded-xl bg-white shadow-2xl ring-1 ring-black/5 transition-all"role="dialog"aria-modal="true">
 {/* Search input */}
 <div className="flex items-center border-b border-slate-200 px-4">
 <svg
 className="h-5 w-5 text-slate-400"fill="none"viewBox="0 0 24 24"stroke="currentColor"strokeWidth={2}
 >
 <circle cx="11"cy="11"r="7"/>
 <path d="m21 21-4.3-4.3"/>
 </svg>
 <input
 ref={inputRef}
 type="text"value={query}
 onChange={(e) => setQuery(e.target.value)}
 onKeyDown={handleKeyDown}
 placeholder="Search for pages, actions, or help..."className="flex-1 border-0 bg-transparent px-4 py-4 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-0"/>
 <kbd className="hidden rounded bg-slate-100 px-2 py-1 text-xs text-slate-500 sm:block">
 ESC
 </kbd>
 </div>

 {/* Results */}
 <div className="max-h-[320px] overflow-y-auto p-2">
 {filteredCommands.length === 0 ? (
 <div className="px-4 py-8 text-center">
 <p className="text-sm text-slate-500">
 No results found for"{query}"</p>
 </div>
 ) : (
 <ul role="listbox">
 {filteredCommands.map((cmd, index) => (
 <li
 key={cmd.id}
 role="option"aria-selected={index === selectedIndex}
 onClick={() => {
 cmd.action();
 setIsOpen(false);
 }}
 onMouseEnter={() => setSelectedIndex(index)}
 className={`flex cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 transition-colors ${
 index === selectedIndex
 ?"bg-emerald-50 text-role-primary":"text-slate-700 hover:bg-slate-50"}`}
 >
 <span
 className={`flex h-8 w-8 items-center justify-center rounded-lg ${
 index === selectedIndex
 ?"bg-emerald-50":"bg-slate-100"}`}
 >
 {cmd.icon}
 </span>
 <div className="flex-1 min-w-0">
 <p className="text-sm font-medium">{cmd.title}</p>
 {cmd.subtitle && (
 <p
 className={`text-xs ${
 index === selectedIndex
 ?"text-role-primary/70":"text-slate-500"}`}
 >
 {cmd.subtitle}
 </p>
 )}
 </div>
 {index === selectedIndex && (
 <kbd className="rounded bg-emerald-50 px-1.5 py-0.5 text-xs">
 Enter
 </kbd>
 )}
 </li>
 ))}
 </ul>
 )}
 </div>

 {/* Footer hint */}
 <div className="flex items-center justify-between border-t border-slate-200 px-4 py-2.5 text-xs text-slate-500">
 <span>
 <kbd className="rounded bg-slate-100 px-1.5 py-0.5">
 ↑↓
 </kbd>{""}
 to navigate
 </span>
 <span>
 <kbd className="rounded bg-slate-100 px-1.5 py-0.5">
 Enter
 </kbd>{""}
 to select
 </span>
 </div>
 </div>
 </div>
 </div>
 );
}

export default CommandPalette;

